import { createApp, defineCustomElement } from "vue";
import { createI18n } from "vue-i18n";
import { useFavicon } from "@vueuse/core";

import "@/index.css";
import router from "@/router";
import App from "@/App.vue";
import useUser from "@/composables/user";
import useConfig from "@/composables/config";

import Example from "./web-components/Example.ce.vue";

import VueScrollTo from "vue-scrollto";
import { VueCookieNext } from "vue-cookie-next";

const ExampleElement = defineCustomElement(Example);
customElements.define("rsc-example", ExampleElement);

async function setup() {
  const { initConfig, config } = useConfig();

  // Config initialisieren, muss zwingend direkt am Anfang passieren!
  await initConfig();

  // favicon setzen
  useFavicon(`${config.backendPath}/css/images/webtexte/favicon.ico`);

  // User vom Server laden
  const { loadUser } = useUser();
  await loadUser();

  // Übersetzungen holen
  const translationsRes = await Promise.all([
    fetch(`${config.apiPath}/getSessionLocale`),
    fetch(`${config.apiPath}/translations?language=de`),
    fetch(`${config.apiPath}/translations?language=en`),
  ]);
  const translations = await Promise.all([
    translationsRes[0].json(),
    translationsRes[1].json(),
    translationsRes[2].json(),
  ]);

  // Anwendung initialisieren
  const app = createApp(App);

  // i18n-Framework initialisieren
  app.use(
    createI18n({
      locale: translations[0],
      messages: { de: translations[1], en: translations[2] },
      legacy: false,
      warnHtmlMessage: false,
    })
  );

  // Router laden
  app.use(router);
  app.use(VueScrollTo);
  app.use(VueCookieNext);

  VueCookieNext.config({ expire: "1y" });

  // Anwendung auf der Seite mounten
  app.mount("#app");
}

setup();
